import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import { createTheme } from '@mui/material/styles';
import { getUserData, updateUser } from 'APIs/AuthApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { login, selectAuth } from 'features/auth/authSlice';
import { UserData } from 'interfaces/UserData.interface';
import React, { SetStateAction, useState } from 'react';
import {
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
  Swiper as ISwiper,
} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import Discover from './Discover';
import Earn from './Earn';
import Welcome from './Welcome';
import Greeting from './Greeting';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

interface IAllProps {
  setOpen: SetStateAction<any>;
}

const All: React.FC<IAllProps> = ({ setOpen }) => {
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [swiper, setSwiper] = useState<ISwiper | null>(null);
  const [updatedUserData, setUpdatedUserData] = useState<UserData | null>(null);
  const [userRequestedCreatorAccess, setUserRequestedCreatorAccess] =
    useState<boolean>(false);
  const lastSlide = () => {
    if (swiper) {
      swiper.slideTo(swiper.slides.length - 1);
    }
  };

  const nextSlide = () => {
    if (swiper) {
      swiper.slideNext();
    }
  };

  const prevSlide = () => {
    if (swiper) {
      swiper.slidePrev();
    }
  };

  const closeModal = () => {
    if (updatedUserData) {
      dispatch(login({ ...updatedUserData }));
    }
    setOpen(false);
  };

  const completeOnBoarding = async () => {
    setLoading(true);
    const updatingFields: any = { seenOnBoarding: true };
    if (userRequestedCreatorAccess) {
      updatingFields.requestedCreatorAccess = true;
    }
    const res = await updateUser({ id: authState.id, ...updatingFields });
    if (res && res?.id === authState.id) {
      const newDataRes = await getUserData();
      setUpdatedUserData(newDataRes);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box sx={{ height: '100%', outline: 'none' }}>
          <Swiper
            onSlideChange={swiper => {
              if (swiper.activeIndex >= swiper.slides.length - 1) {
                completeOnBoarding();
              }
            }}
            onSwiper={swiper => {
              setSwiper(swiper);
            }}
            cssMode={true}
            navigation={true}
            pagination={true}
            mousewheel={true}
            keyboard={true}
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="mySwiper"
            style={{ display: 'flex', paddingBottom: '20px', color: '#ffffff' }}
            // sx={{"& .swiper-pagination-bullet-active": {
            //   backgroundColor:"#ffffff",
            // }}}
          >
            <SwiperSlide>
              <Welcome
                loading={loading}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
                lastSlide={lastSlide}
              />
            </SwiperSlide>
            <SwiperSlide>
              <Discover
                loading={loading}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
                lastSlide={lastSlide}
              />
            </SwiperSlide>
            <SwiperSlide>
              <Earn
                loading={loading}
                prevSlide={prevSlide}
                closeModal={closeModal}
                handleUserRequestedCreatorAccess={() => {
                  setUserRequestedCreatorAccess(true);
                  nextSlide();
                }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <Greeting
                loading={loading}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
                closeModal={closeModal}
              />
            </SwiperSlide>
          </Swiper>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default All;
